import { get } from 'lodash'

export default function isValidRegistration(registration) {
  const user = registration.user

  if (!get(registration, 'salutation', '').trim()) {
    return false
  }

  if (!get(user, 'firstName', '').trim()) {
    return false
  }

  if (!get(user, 'lastName', '').trim()) {
    return false
  }

  if (!registration.tc) {
    return false
  }

  if (user.password == null) {
    return false
  }

  if (!get(user, 'phone', '').trim()) {
    return false
  }

  if (!get(user, 'country', '').trim()) {
    return false
  }

  return true
}
